// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"_1zKSa","page":"_2DYeu","title":"_1o2WR","description":"_26zKp","loginButtonContainer":"_27qkF"};